"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="GlobalApplicationSettings.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxGlobalApplicationSettings object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxGlobalApplicationSettings = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxStringPair_1 = require("./HxStringPair");
var HxGlobalApplicationSettings = /** @class */ (function (_super) {
    __extends(HxGlobalApplicationSettings, _super);
    function HxGlobalApplicationSettings(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxGlobalApplicationSettings, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxGlobalApplicationSettings.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '3DB':
                        this.accentColor = v;
                        break;
                    case '473':
                        this.applyAllSettings = v;
                        break;
                    case '6E0':
                        this.autoOpenReadingPane = v;
                        break;
                    case 'CEF':
                        this.autoSelectAccentColor = v;
                        break;
                    case '3E0':
                        this.backgroundImage = v;
                        break;
                    case 'A6D':
                        this.backgroundImageDarkness = v;
                        break;
                    case '3DD':
                        this.backgroundMode = v;
                        break;
                    case '3DE':
                        this.backgroundVersion = v;
                        break;
                    case '4D6':
                        this.caretBrowsingEnabled = v;
                        break;
                    case '863':
                        this.contactPictureEnabled = v;
                        break;
                    case 'CF6':
                        this.daysToPrescheduleReminders = v;
                        break;
                    case 'C06':
                        this.density = v;
                        break;
                    case 'E57':
                        this.includeErrorToasts = v;
                        break;
                    case '1300':
                        this.mailAccountSettings_AllowSMIMECertificatesWithoutMatchingEmailAddress = v;
                        break;
                    case '47E':
                        this.mailAccountSettings_AlwaysEncrypt = v;
                        break;
                    case '47D':
                        this.mailAccountSettings_AlwaysSign = v;
                        break;
                    case 'F9C':
                        this.mailAccountSettings_ClearSignSignedMessages = v;
                        break;
                    case '65D':
                        this.mailAccountSettings_ConversationViewMode = v;
                        break;
                    case 'E27':
                        this.mailAccountSettings_DefaultFontHtml = Buffer.from(v, 'base64');
                        break;
                    case 'F9D':
                        this.mailAccountSettings_EncryptingAlgorithm = v;
                        break;
                    case '480':
                        this.mailAccountSettings_EncryptingCertificateHash = Buffer.from(v, 'base64');
                        break;
                    case 'FB8':
                        this.mailAccountSettings_IncludeChainCertsInMessage = v;
                        break;
                    case 'E28':
                        this.mailAccountSettings_IsDefaultFontUserModified = v;
                        break;
                    case '47C':
                        this.mailAccountSettings_IsExternalContentEnabled = v;
                        break;
                    case '476':
                        this.mailAccountSettings_IsSignatureEnabled = v;
                        break;
                    case '475':
                        this.mailAccountSettings_IsSignatureUserModified = v;
                        break;
                    case 'D66':
                        this.mailAccountSettings_IsSMIMEExternalContentEnabled = v;
                        break;
                    case '477':
                        this.mailAccountSettings_QuickActionPrimary = v;
                        break;
                    case '478':
                        this.mailAccountSettings_QuickActionSecondary = v;
                        break;
                    case '6DA':
                        this.mailAccountSettings_SignatureHtml = Buffer.from(v, 'base64');
                        break;
                    case 'B6C':
                        var mailAccountSettings_SignatureImagesValues = v;
                        this.mailAccountSettings_SignatureImages = new Array(mailAccountSettings_SignatureImagesValues.length);
                        for (var i = 0; i < mailAccountSettings_SignatureImagesValues.length; i++) {
                            this.mailAccountSettings_SignatureImages[i] = HxStringPair_1.deserializeHxStringPair(mailAccountSettings_SignatureImagesValues[i]);
                        }
                        break;
                    case 'F9E':
                        this.mailAccountSettings_SigningAlgorithm = v;
                        break;
                    case '47F':
                        this.mailAccountSettings_SigningCertificateHash = Buffer.from(v, 'base64');
                        break;
                    case '6E1':
                        this.markAsRead = v;
                        break;
                    case '6E2':
                        this.markAsReadWaitTimeSec = v;
                        break;
                    case 'E58':
                        this.maxToastEntries = v;
                        break;
                    case '6DC':
                        this.navigationPaneFoldersEnabled = v;
                        break;
                    case '76A':
                        this.navPaneResizing = v;
                        break;
                    case 'A09':
                        this.resizeImageToSize = v;
                        break;
                    case '7F5':
                        this.richContentEnabled = v;
                        break;
                    case 'E9D':
                        this.shouldIgnoreAppStateForToasts = v;
                        break;
                    case 'F35':
                        this.shouldPerformServerUndo = v;
                        break;
                    case '6E3':
                        this.showConversationPreviewText = v;
                        break;
                    case '9CE':
                        this.showReadingPaneEnabled = v;
                        break;
                    case '3DC':
                        this.theme = v;
                        break;
                    case 'E99':
                        this.timeZoneId = v;
                        break;
                    case 'E59':
                        this.toastsSetting = v;
                        break;
                    case '9B4':
                        this.userPreferredMessageListWidth = v;
                        break;
                    case '9B5':
                        this.userPreferredNavPaneWidth = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return HxGlobalApplicationSettings;
}(HxObject_1.default));
exports.HxGlobalApplicationSettings = HxGlobalApplicationSettings;
exports.default = HxGlobalApplicationSettings;
